import React from 'react';
import { ReferralProps } from './interface';

declare global {
  // eslint-disable-next-line @typescript-eslint/no-namespace
  namespace JSX {
    interface IntrinsicElements {
      'impact-popup': {
        widget?: string;
        children?: React.ReactNode;
      };
    }
  }
}

const ReferralPopup = ({ url }: ReferralProps) => {
  return <impact-popup widget={url}>Refer a Friend</impact-popup>;
};

export default ReferralPopup;
